export const autoRefreshRate = 300000
